import { render, staticRenderFns } from "./welfareDaily.vue?vue&type=template&id=30d19ba6&scoped=true&"
import script from "./welfareDaily.vue?vue&type=script&lang=js&"
export * from "./welfareDaily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d19ba6",
  null
  
)

export default component.exports